import { render, staticRenderFns } from "./AreaMainPage.vue?vue&type=template&id=4054c538&scoped=true&"
import script from "./AreaMainPage.vue?vue&type=script&lang=js&"
export * from "./AreaMainPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4054c538",
  null
  
)

export default component.exports